import { MenuItem } from "../types";

export const menuData: MenuItem[] = [
  {
    id: "home",
    title: "Home",
    path: "/home",
    icon: "LayoutDashboard",
    children: [
      { id: "overview", title: "Overview - Home", path: "/home/overview" },
      // { id: 'custom-dashboards', title: 'Custom Dashboards', path: '/home/custom-dashboards' }
    ],
  },
  {
    id: "new-business",
    title: "New Business Setup",
    path: "/new-business-setup",
    icon: "",
  },
  {
    id: "products",
    title: "Products",
    path: "/products",
    icon: "Package",
    children: [
      { id: "products", title: "Products", path: "/products/products" },
      {
        id: "product-groups",
        title: "Product Groups",
        path: "/products/product-groups",
      },
      {
        id: "inventory-adjustments",
        title: "Inventory Adjustments",
        path: "/products/inventory-adjustments",
      },
      {
        id: "transfer-orders",
        title: "Transfer Orders",
        path: "/products/transfer-orders",
      },
      {
        id: "product-categories",
        title: "Product Categories",
        path: "/products/product-categories",
      },
      {
        id: "product-units",
        title: "Product Units",
        path: "/products/product-units",
      },
      {
        id: "convert-product",
        title: "Convert Product",
        path: "/products/convert-product",
      },
    ],
  },
  {
    id: "purchases",
    title: "Purchases",
    path: "/purchases",
    icon: "ShoppingBag",
    children: [
      { id: "suppliers", title: "Suppliers", path: "/purchases/suppliers" },
      {
        id: "supplier-group",
        title: "Supplier Group",
        path: "/purchases/supplier-group",
      },
      { id: "expenses", title: "Expenses", path: "/purchases/expenses" },
      {
        id: "recurring-expenses",
        title: "Recurring Expenses",
        path: "/purchases/recurring-expenses",
      },
      {
        id: "purchase-orders",
        title: "Purchase Orders",
        path: "/purchases/purchase-orders",
      },
      { id: "bills", title: "Bills", path: "/purchases/bills" },
      {
        id: "payments-made",
        title: "Payments Made",
        path: "/purchases/payments-made",
      },
      {
        id: "supplier-credits",
        title: "Supplier Credits",
        path: "/purchases/supplier-credits",
      },
    ],
  },
  {
    id: "sales",
    title: "Sales",
    path: "/sales",
    icon: "DollarSign",
    children: [
      { id: "customers", title: "Customers", path: "/sales/customers" },
      {
        id: "customer-groups",
        title: "Customer Groups",
        path: "/sales/customer-group",
      },
      {
        id: "sales-orders",
        title: "Sales Orders",
        path: "/sales/sales-orders",
      },
      { id: "invoices", title: "Invoices", path: "/sales/invoices" },
      {
        id: "payments-received",
        title: "Payments Received",
        path: "/sales/payments-received",
      },
      {
        id: "credit-notes",
        title: "Credit Notes",
        path: "/sales/credit-notes",
      },
      {
        id: "retail-sales",
        title: "Retail Sales",
        path: "/sales/retail-sales",
      },
    ],
  },
  {
    id: "banking",
    title: "Banking",
    path: "/banking",
    icon: "Building",
  },
  {
    id: "budget",
    title: "Budget",
    path: "/budget",
    icon: "CreditCard",
  },
  {
    id: "accountant",
    title: "Accountant",
    path: "/accountant",
    icon: "Users",
    children: [
      {
        id: "chart-of-accounts",
        title: "Chart of Accounts",
        path: "/accountant/chart-of-accounts",
      },
      {
        id: "manual-journals",
        title: "Manual Journals",
        path: "/accountant/manual-journals",
      },
      {
        id: "transaction-locking",
        title: "Transaction Locking",
        path: "/accountant/transaction-locking",
      },
    ],
  },
  {
    id: "report",
    title: "Reports",
    path: "/reports",
    icon: "Cash",
    children: [
      {
        id: "report-overview",
        title: "Reports Overview",
        path: "/reports/overview",
      },
      {
        id: "business-overview",
        title: "Business Overview",
        path: "/reports/business-overview",
        children: [
          {
            id: "profit-and-loss",
            title: "Profit and Loss",
            path: "/reports/business-overview/profit-and-loss",
          },
          {
            id: "cash-flow-statement",
            title: "Cash Flow Statement",
            path: "/reports/business-overview/cash-flow-statement",
          },
          {
            id: "balance-sheet",
            title: "Balance Sheet",
            path: "/reports/business-overview/balance-sheet",
          },
          {
            id: "movement-of-equity",
            title: "Movement of Equity",
            path: "/reports/business-overview/movement-of-equity",
          },
        ],
      },
      {
        id: "accountant",
        title: "Accountant",
        path: "/reports/accountant",
        children: [
          {
            id: "account-transactions",
            title: "Account Transactions",
            path: "/reports/accountant/account-transactions",
          },
          {
            id: "account-type-summary",
            title: "Account Type Summary",
            path: "/reports/accountant/account-type-summary",
          },
          {
            id: "general-ledger",
            title: "General Ledger",
            path: "/reports/accountant/general-ledger",
          },
          {
            id: "detailed-general-ledger",
            title: "Detailed General Ledger",
            path: "/reports/accountant/detailed-general-ledger",
          },
          {
            id: "journal-report",
            title: "Journal Report",
            path: "/reports/accountant/journal-report",
          },
          {
            id: "trial-balance",
            title: "Trial Balance",
            path: "/reports/accountant/trial-balance",
          },
        ],
      },
      {
        id: "sales",
        title: "Sales",
        path: "/reports/sales",
        children: [
          {
            id: "sales-by-customer",
            title: "Sales by Customer",
            path: "/reports/sales/sales-by-customer",
          },
          {
            id: "sales-by-product",
            title: "Sales by Product",
            path: "/reports/sales/sales-by-product",
          },
          {
            id: "sales-by-sales-person",
            title: "Sales by Sales Person",
            path: "/reports/sales/sales-by-sales-person",
          },
        ],
      },
      {
        id: "inventory",
        title: "Inventory",
        path: "/reports/inventory",
        children: [
          {
            id: "inventory-summary",
            title: "Inventory Summary",
            path: "/reports/inventory/inventory-summary",
          },
          {
            id: "stock-summary-report",
            title: "Stock Summary Report",
            path: "/reports/inventory/stock-summary-report",
          },
          {
            id: "inventory-valuation-summary",
            title: "Inventory Valuation Summary",
            path: "/reports/inventory/inventory-valuation-summary",
          },
          {
            id: "product-sales-report",
            title: "Product Sales Report",
            path: "/reports/inventory/product-sales-report",
          },
          {
            id: "warehouse-report",
            title: "Warehouse Report",
            path: "/reports/inventory/warehouse-report",
          },
          {
            id: "inventory-aging-report",
            title: "Inventory Aging Report",
            path: "/reports/inventory/inventory-aging-report",
          },
          {
            id: "Inventory-expiry-report",
            title: "Inventory Expiry Report",
            path: "/reports/inventory/inventory-expiry-report",
          },
        ],
      },
      {
        id: "payables",
        title: "Payables",
        path: "/reports/payables",
        children: [
          {
            id: "ap-aging-summary",
            title: "Account Transactions",
            path: "/reports/payables/ap-aging-summary",
          },
          {
            id: "ap-aging-details",
            title: "AP Aging Details",
            path: "/reports/payables/ap-aging-details",
          },
          {
            id: "bills-details",
            title: "Bills Details",
            path: "/reports/payables/bills-details",
          },
          {
            id: "supplier-balance-details",
            title: "Supplier Balance Details",
            path: "/reports/payables/supplier-balance-details",
          },
          {
            id: "supplier-balance-summary",
            title: "Supplier Balance Summary",
            path: "/reports/payables/supplier-balance-summary",
          },
          {
            id: "purchase-order-details",
            title: "Purchase Order Details",
            path: "/reports/payables/purchase-order-details",
          },
          {
            id: "payable-summary",
            title: "Payable Summary",
            path: "/reports/payables/payable-summary",
          },
          {
            id: "payable-details",
            title: "Payable Details",
            path: "/reports/payables/payable-details",
          },
        ],
      },
      {
        id: "receivables",
        title: "Receivables",
        path: "/reports/receivables",
        children: [
          {
            id: "ar-aging-summary",
            title: "AR Aging Summary",
            path: "/reports/receivables/ar-aging-summary",
          },
          {
            id: "ar-aging-details",
            title: "AR Aging Details",
            path: "/reports/receivables/ar-aging-details",
          },
          {
            id: "invoice-details",
            title: "Invoice Details",
            path: "/reports/receivables/invoice-details",
          },
          {
            id: "customer-balance-summary",
            title: "Customer Balance Summary",
            path: "/reports/receivables/customer-balance-summary",
          },
          {
            id: "customer-balance-details",
            title: "Customer Balance Details",
            path: "/reports/receivables/customer-balance-details",
          },
          {
            id: "sales-order-details",
            title: "Sales Order Details",
            path: "/reports/receivables/sales-order-details",
          },
          {
            id: "receivable-summary",
            title: "Receivable Summary",
            path: "/reports/receivables/receivable-summary",
          },
          {
            id: "receivable-details",
            title: "Receivable Details",
            path: "/reports/receivables/receivable-details",
          },
        ],
      },
      {
        id: "purchase",
        title: "Purchase",
        path: "/reports/purchase",
        children: [
          {
            id: "purchase-by-supplier",
            title: "Purchase by Supplier",
            path: "/reports/purchase/purchase-by-supplier",
          },
          {
            id: "purchase-by-product",
            title: "Purchase by Product",
            path: "/reports/purchase/purchase-by-product",
          },
        ],
      },
      {
        id: "payments-received",
        title: "Payments Received",
        path: "/reports/payments-received",
        children: [
          {
            id: "payments-received",
            title: "Payments Received",
            path: "/reports/payments-received/payments-received",
          },
          {
            id: "refund-history",
            title: "Refund History",
            path: "/reports/payments-received/refund-history",
          },
          {
            id: "credit-note-details",
            title: "Credit Note Details",
            path: "/reports/payments-received/credit-note-details",
          },
        ],
      },
      {
        id: "payments-made",
        title: "Payments Made",
        path: "/reports/payments-made",
        children: [
          {
            id: "payments-made",
            title: "Payments Made",
            path: "/reports/payments-made/payments-made",
          },
          {
            id: "refund-history",
            title: "Refund History",
            path: "/reports/payments-made/refund-history",
          },
          {
            id: "supplier-credit-details",
            title: "Supplier Credit Details",
            path: "/reports/payments-made/supplier-credit-details",
          },
        ],
      },
      {
        id: "expense",
        title: "Expense",
        path: "/reports/expense",
        children: [
          {
            id: "expense-details",
            title: "Expense Details",
            path: "/reports/purchase/expense-details",
          },
          {
            id: "expense-by-category",
            title: "Expense by Category",
            path: "/reports/purchase/expense-by-category",
          },
        ],
      },
      {
        id: "currency",
        title: "Currency",
        path: "/reports/currency",
        children: [
          {
            id: "realized-gain-or-loss",
            title: "Realized Gain or Loss",
            path: "/reports/currency/realized-gain-or-loss",
          },
          {
            id: "unrealized-gain-or-loss",
            title: "Unrealized Gain or Loss",
            path: "/reports/currency/unrealized-gain-or-loss",
          },
        ],
      },
      {
        id: "pos-sales",
        title: "POS Sales",
        path: "/reports/pos-sales",
        children: [
          {
            id: "pos-sales-by-customer",
            title: "POS Sales by Customer",
            path: "/reports/pos-sales/pos-sales-by-customer",
          },
          {
            id: "pos-sales-by-products",
            title: "POS Sales by Products",
            path: "/reports/pos-sales/pos-sales-by-products",
          },
        ],
      },
    ],
  },
  {
    id: "settings",
    title: "Settings",
    path: "/settings",
    icon: "Settings",
    children: [
      {
        id: "advanced-options",
        title: "Advanced Options",
        path: "/settings/advanced-options",
      },
      { id: "branches", title: "Branches", path: "/settings/branches" },
      { id: "currencies", title: "Currencies", path: "/settings/currencies" },
      {
        id: "delivery-methods",
        title: "Delivery Methods",
        path: "/settings/DeliveryMethods",
      },
      {
        id: "opening-balances",
        title: "Opening Balances",
        path: "/settings/opening-balances",
      },
      {
        id: "payment-methods",
        title: "Payment Methods",
        path: "/settings/PaymentMethods",
      },
      {
        id: "payment-modes",
        title: "Payment Modes",
        path: "/settings/PaymentModes",
      },
      {
        id: "pos-payment-modes",
        title: "Pos Payment Modes",
        path: "/settings/PosPaymentModes",
      },
      {
        id: "product-conversion-link",
        title: "Product Conversion Link",
        path: "/settings/ProductConversationLink",
      },
      { id: "profile", title: "Profile", path: "/settings/profile" },
      { id: "reasons", title: "Reasons", path: "/settings/reasons" },
      { id: "roles", title: "Roles", path: "/settings/roles" },
      {
        id: "sales-persons",
        title: "Sales Persons",
        path: "/settings/SalesPersons",
      },
      { id: "taxes", title: "Taxes", path: "/settings/taxes" },
      {
        id: "transaction-number-series",
        title: "Transaction Number Series",
        path: "/settings/TransactionNumberSeries",
      },
      { id: "users", title: "Users", path: "/settings/users" },
      { id: "warehouses", title: "Warehouses", path: "/settings/warehouses" },
      { id: "work-center", title: "Work Center", path: "/settings/WorkCenter" },
    ],
  },
];
